<div class="wrapper">
	@if (!price?.isError && price?.price) {
		<div fxLayout="row" fxLayoutGap="30px" [ngClass]="{ 'is-loading': price?.isFetching }">
			<div fxFlex class="price-note">
				<span i18n>Price with selected product options without delivery fees.</span>
			</div>
			<div data-cy="priceNumber" class="price-number">
				@if (price?.isFetching) {
					<g-icon [@spinnerTrigger]="true" class="spinner" [icon]="icons.faSpinner" pulse />
				}

				@if (showPricesWithTax$ | async) {
					<span> {{ price?.price?.price_with_tax || 0 | number: '1.2-2' }} € </span>
				} @else {
					<span> {{ price?.price?.price_without_tax || 0 | number: '1.2-2' }} € </span>
				}
				<g-vat-selector [taxMultiplier]="price?.price?.tax_multiplier" />
			</div>
		</div>
	}

	@if (isVariableProduct && !price?.isError && !price?.price) {
		<div fxLayout="row" fxLayoutGap="30px" [ngClass]="{ 'is-loading': price?.isFetching }" *ngIf="">
			<div fxFlex class="price-note">
				<span i18n>Select all options to get the price</span>
			</div>
			@if (price?.isFetching) {
				<g-icon [@spinnerTrigger]="true" class="spinner" [icon]="icons.faSpinner" pulse />
			}

			<div class="price-number" data-cy="priceNumber">
				@if (showPricesWithTax$ | async) {
					<span *ngIf=""> - € </span>
				}
			</div>
		</div>
	}
	@if (price?.isError) {
		<div class="pricing-error" data-cy="pricingError" i18n>Pricing Error</div>
	}
</div>
